import { h } from "preact";
import { useState } from "preact/hooks";

import classname from "../../../../foundation/utils/classname";
import Input from "../../Input";
import Alert, { AlertProps } from "..";

import styles from "./DeleteAlert.module.css";

type BaseProps = Pick<AlertProps, "description" | "onClose">;

interface Props extends BaseProps {
    itemName: string;
    inputPlaceholder: string;
    info?: string;
    onDelete: () => void;
}

function DeleteAlert({
    description,
    itemName,
    inputPlaceholder,
    info,
    onDelete,
    onClose
}: Props) {
    const [value, setValue] = useState("");

    function handleInput(event: Event) {
        setValue((event.target as HTMLInputElement).value);
    }

    const positiveButtonDisabled = itemName !== value;

    const title = `Delete “${itemName}”?`;

    return (
        <Alert
            class={styles.deleteAlert}
            title={title}
            description={description}
            primaryButtonProps={{
                children: "Delete",
                disabled: positiveButtonDisabled,
                onClick: onDelete
            }}
            secondaryButtonProps={{
                children: "Cancel" // TODO-electron-post-release-onur: Update copies here and in the usages of this component
            }}
            onClose={onClose}>
            <div class={styles.content}>
                {
                    info && (
                        <span class={classname(styles.info, "caption-1")}>{info}</span>
                    )
                }
                <Input
                    class={styles.input}
                    placeholder={inputPlaceholder}
                    autoFocus
                    onInput={handleInput}/>
            </div>
        </Alert>
    );
}

export default DeleteAlert;
